module.exports = __webpack_public_path__ + "img/iconmonstr-lock-3 (1).a7fddbc6.svg";